<template>
    <div>
        <button @click="showEmbedModal" :class="btnClass" type="button" class="btn font-semibold rounded-full focus:outline-none">
            <i class="fad fa-video fa-lg"></i>
            <span v-if="btnText" class="ml-2">
                {{ btnText }}
            </span>
        </button>

        <!-- <portal v-if="showModal" to="modals" transition="fade-transition"> -->
        <portal v-if="showModal" to="modals">
            <video-modal v-if="showModal" @close="onModalClosed" :title="title" :source-url="sourceUrl" />
        </portal>
    </div>
</template>

<script>
export default {
    props: [
        'source-url',
        'title',
        'btn-text',
        'btn-class'
    ],

    data: () => ({
        showModal: false
    }),

    created() {},

    mounted() {},

    computed: {},

    methods: {
        onModalClosed() {
            this.showModal = false;
        },

        showEmbedModal() {
            this.showModal = true;
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
